<script setup lang="ts">
import { UIAlert } from "@gohighlevel/ghl-ui";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <!-- Wrapper carries the spacing: UIAlert does not inherit attrs on its root. -->
  <div data-testid="url-single-info" class="mb-3">
    <UIAlert id="url-single-info" type="warning" :closable="false">
      <template #content>
        <span class="text-[13px] leading-[18px]">
          {{ t("common.urlField.singleUrlInfo") }}
        </span>
      </template>
    </UIAlert>
  </div>
</template>
